export var CustomStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 999999999999
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    font: 'initial'
  }
};
export var DeleteReason = {
  SOLD_BY_OLX: 'sold_by_olx',
  SOLD_BY_OTHER: 'sold_by_others',
  NOT_SOLD: 'not_sold',
  OTHER_REASON: 'other_reason'

  // Essa constante também é usada como object name de tracking
};
export var Step = {
  DELETE_AD: 'ad_deleting',
  AD_DELETED: 'ad_deleting_confirmation',
  SURVEY: 'ad_survey',
  SURVEY_SENT: 'ad_survey_sent',
  BUMP: 'ad_bump',
  DELETE_ERROR: 'delete_error'
};